import React, { useContext, useEffect } from "react";
import Heading from "@amzn/meridian/heading";
import Row from "@amzn/meridian/row";
import Text from "@amzn/meridian/text";
import Tooltip from "@amzn/meridian/tooltip";
import { OverviewContext } from "../overview/context/OverviewContext";
import { CycleFilterContext } from "../overview/context/CycleFilterContext";
import { PVAOverviewContext } from "../overview/context/PVAOverviewContext";
import { FormattedMessage, injectIntl } from "react-intl";
import { getDocumentURL } from "../handler/ParentDataHandler";
import { getBaseUrl } from "../outboundAmzl/util/Util";

const FPHView = (props) => {
  const { cycles } = useContext(CycleFilterContext);
  const { pvaData } = useContext(PVAOverviewContext);
  const { viewModel, dispatch } = useContext(OverviewContext);

  const getFPHData = () => {
    getDocumentURL().then((result) => {
      const baseUrl = getBaseUrl(result);
      dispatch({
        type: "LOAD_FPH_OVERVIEW",
        data: {
          filter: cycles.selectedCycles,
          dispatcher: dispatch,
          processName: props.fph.processName,
          baseUrl: baseUrl,
        },
      });
      dispatch({
        type: "LOAD_TARGET_DATA",
        data: {
          filter: cycles.selectedCycles,
          dispatcher: dispatch,
          processName: "target",
        },
      });
    });
  };

  useEffect(() => {
    if (cycles.allCycles.length > 0) {
      getFPHData();
      const interval = setInterval(() => {
        if (!document.hidden) {
          getFPHData();
        }
      }, props.fph.refreshRate);
      return () => clearInterval(interval);
    }
  }, [cycles]);

  return (
    <div>
      <div className="overview-fph">
        <Heading level={2} type="h300" alignment="left">
          <Tooltip
            position="right"
            title={props.intl.formatMessage({
              id: viewModel.fph[props.fph.processName].tooltip,
              defaultMessage:
                viewModel.fph[props.fph.processName].tooltipMessage,
            })}
          >
            <FormattedMessage
              id={viewModel.fph[props.fph.processName].title}
              defaultMessage={
                viewModel.fph[props.fph.processName].defaultMessage
              }
            />
          </Tooltip>
        </Heading>
      </div>
      <Row width="100%" widths={["grid-6", "grid-6"]}>
        <div>
          <Text type="b100">
            <FormattedMessage id="fph.target" defaultMessage="Target" />
          </Text>
          {props.fph.processName === "induct" ? (
            <Text type="d50">
              {pvaData.targetData.INDUCT_FPH
                ? pvaData.targetData.INDUCT_FPH
                : 0}
            </Text>
          ) : (
            ""
          )}
          {props.fph.processName === "sort" ? (
            <Text type="d50">
              {pvaData.targetData.STOW_FPH ? pvaData.targetData.STOW_FPH : 0}
            </Text>
          ) : (
            ""
          )}
          {props.fph.processName === "pick" ? (
            <Text type="d50">
              {pvaData.targetData.PICK_FPH ? pvaData.targetData.PICK_FPH : 0}
            </Text>
          ) : (
            ""
          )}
          {props.fph.processName === "stage" ? (
            <Text type="d50">
              {pvaData.targetData.STAGE_FPH ? pvaData.targetData.STAGE_FPH : 0}
            </Text>
          ) : (
            ""
          )}
        </div>
        <div>
          <Text type="b100">
            <FormattedMessage id="fph.actual" defaultMessage="Actual" />
          </Text>
          <Text type="d50">{viewModel.fph[props.fph.processName].actual}</Text>
        </div>
      </Row>
    </div>
  );
};

export default injectIntl(FPHView);



// WEBPACK FOOTER //
// ./src/components/FPH/FPHView.js